'use client';

import React from 'react';
import AISupportAgent from './components/AISupportAgent';

export default function SupportPage() {
  return (
    <div className="fixed inset-0 top-[64px] bg-white z-0 flex flex-col">
      {/* 
          64px is approx header height. 
          We want the chat to fill the remaining screen space.
      */}
      <main className="flex-1 min-h-0 w-full max-w-5xl mx-auto p-4 md:p-6 flex flex-col">
        <h1 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
          How can we help you today?
        </h1>
        <div className="flex-1 min-h-0 h-full">
          <AISupportAgent />
        </div>
      </main>
    </div>
  );
}